import { render } from "./ContactUs.vue?vue&type=template&id=6fda21a8&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=6fda21a8&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fda21a8"]])

export default __exports__